import script from "./GansuMap.vue?vue&type=script&setup=true&lang=js"
export * from "./GansuMap.vue?vue&type=script&setup=true&lang=js"

import "./GansuMap.vue?vue&type=style&index=0&id=20cd3024&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20cd3024"]])

export default __exports__